/* eslint-disable max-lines */
import bigDataLog from '@/utils/bigDataLog'
import registerUpload from '../../../../../../components/upload/Index.vue'
import preview from '../../../../../../components/viewAttachment.vue'
import mSelect from '../../../../../../components/Select.vue'
import NewUploadVersion from './newUploadVersion/Index.vue'
import advanceDialog from '@/components/lots/otpAdvanceDialog'
import { uploadList } from './uploadListConfig.js'
import { PERSON, DATE_FOREVER } from '../../../../../../constant/constant.js'
import { identityVerify, phoneVerify, driverLicenseVerify } from '../../../../../../constant/formRegular.js'
import { driverPublicForm, idCardBringOutFieldsConfig } from './addOrEditDialogForm.js'
import {
    addDriver,
    downloadAttachment,
    editDriver,
    getExample,
    getLoginUser,
    revokeApprove,
    checkWPH,
} from '../../../../../../api/register/driver.js'
import { verifyDate } from '../../../../../../utils/common.js'
import { getCitys, getCountrys, getProvinces } from '../../../../../../utils/getArea.js'
import { dictWithUrl } from '@/components/lots/api'
import ViewDelegateFile from './viewDelegateFile.vue'
import rules from './addOrEditDialogRule.js'
import addOrEditDialogMethods from './addOrEditDialogMethods.js'
import { DELEGATE_TYPE, stamperParams } from './newUploadVersion/config.js'

const THREE = 3
export default {
    name: 'add-or-edit-dialog',
    components: { mSelect, advanceDialog, registerUpload, preview, ViewDelegateFile, NewUploadVersion },
    props: {
        openAddOrEditDialog: {
            type: Boolean,
            default() {
                return false
            },
        },
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierType: '',
                    supplierName: '',
                    propertyNature: '',
                }
            },
        },
        addOrEdit: {
            type: Boolean,
            default() {
                return false
            },
        },
        id: {
            type: [String, Number],
            default() {
                return ''
            },
        },
        manage: {
            type: Boolean,
            default() {
                return false
            },
        },
        supplierCode: {
            type: String,
            default() {
                return ''
            },
        },
        corporateIdCard: {
            type: String,
            default() {
                return ''
            },
        },
        propertyNature: {
            type: String,
            default() {
                return ''
            },
        },
        approve: {
            type: Boolean,
            default() {
                return false
            },
        },
        wantDelegate: {
            type: Boolean,
            default() {
                return false
            },
        },
        isShow: {
            type: Boolean,
            default() {
                return true
            },
        },
        isSupplier: {
            type: Boolean,
            default() {
                return !!this.$store.state.supplier
            },
        },
        approvalStatus: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        const idEffectiveDate = (rule, value, callback) => {
            // 身份证有效期校验
            const idStartDate = new Date(this.form.idCardStartDate).getTime() // 获取身份证生效时间戳
            const timestamp = new Date(value).getTime() // 获取的截止时间戳
            const time = new Date().getTime() // 获取的当前时间
            if (timestamp - time <= 0) {
                callback(new Error('身份证必须大于当前时间'))
            } else if (timestamp - idStartDate <= 0) {
                callback(new Error('身份证必须大于起始日期'))
            } else {
                callback()
            }
        }
        const driveEffectiveDate = (rule, value, callback) => {
            // 驾驶证有效期校验
            const driveStartDate = new Date(this.form.driveStartDate).getTime() // 获取驾驶证生效时间戳
            const timestamp = new Date(value).getTime() // 获取的截止时间戳
            const time = new Date().getTime() // 获取的当前时间
            if (timestamp - time <= 0) {
                callback(new Error('驾驶证必须大于当前时间'))
            } else if (timestamp - driveStartDate <= 0) {
                callback(new Error('驾驶证必须大于起始日期'))
            } else {
                callback()
            }
        }
        const drivingNoRule = (rule, value, callback) => {
            if (this.form.idCard !== value) {
                callback(new Error('驾驶证与身份证号码需要一致'))
            } else {
                callback()
            }
        }
        return {
            // // 是否显示新版本页面（控制新旧版切换），目前已全部切换至新版，旧版入口已去掉
            // isNewUploadVersion: true,
            // 是否主体性质为法人
            isLegalPersonSupplier: false,
            path: process.env.BASE_URL,
            DELEGATE_TYPE,
            stamperParams,
            delegateOnline: '', // 当前委派函必填项0 == 委派函、委派时间必填  1 == 选择签署人、委派时间必填
            showDelegateFlag: false, // 查看委派函弹窗
            APPROVE_PEDDING: '10', // 审批状态为审批中
            delegateDisabled: true,
            showDelegateUpload: false,
            btnpermission: '', // 委派函权限控制
            imgSrcPathObj: {},
            loading: false,
            pickerOptionsEnd: {
                disabledDate: time => {
                    return (
                        time.getTime() <= new Date(new Date().toLocaleDateString()).getTime()
                        || time.getTime() >= new Date(new Date().toLocaleDateString()).getTime() + 365 * 3600 * 24 * 1000
                    )
                },
            },
            pickerOptionsStart: {
                disabledDate: time => {
                    return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
                },
            },
            sessionStorage,
            approveInfo: {
                approvalUserName: '', // 审批人(分公司)
                approvalStatus: '', // 审批进度
                approvalStatusText: '', // 审批进度文本
                commitTime: '', // 提交时间
                approvalOpinion: '', // 驳回理由
                approvalTime: '', // 提交时间
                commitUserCode: '',
                headquartersApprovalName: '', // 审批人(总部)
                fdId: '', // MIP审批流程编码
                approvalModeText: '', // 审批模式
                businessTypeText: '', // 业务类型
            },
            dict: {},
            firstFlag: 0,
            attachmentList: [],
            allAttachmentList: [],
            closeOnClickModal: false,
            supplierCode_: '',
            corporateIdCard_: '',
            rowData: {},
            attachmentShow: false,
            editDisabled: false,
            uploadDisplayType: 'icon',
            title: '新增',
            allow: false,
            countryOptions: [],
            provinceOptions: [],
            cityOptions: [],
            form: JSON.parse(JSON.stringify(driverPublicForm)),
            uploadList: uploadList,
            rules: {
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: ['blur', 'change'] },
                    { pattern: identityVerify, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] },
                ],
                phoneNo: [
                    { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
                ],
                drivingLicence: [
                    { required: true, message: '请输入驾驶证号', trigger: ['blur', 'change'] },
                    { pattern: driverLicenseVerify, message: '请输入正确格式的驾驶证号', trigger: ['blur', 'change'] },
                    { validator: drivingNoRule, trigger: ['blur', 'change'] },
                ],
                idCardEndDate: [
                    { required: true, message: '请选择身份证件有效期', trigger: ['blur', 'change'] },
                    { validator: idEffectiveDate, trigger: ['blur', 'change'] },
                ],
                driveEndDate: [
                    { required: true, message: '请选择驾驶证件有效期', trigger: ['blur', 'change'] },
                    { validator: driveEffectiveDate, trigger: ['blur', 'change'] },
                ],
                onWayContactPhone: [
                    { required: false, trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
                ],
                ...rules,
            },
            formDiff: false,
        }
    },
    methods: {
        ...addOrEditDialogMethods,
        hasDiff(v){
            this.formDiff = v
        },
        startChange(val) {
            this.pickerOptionsEnd = {
                disabledDate: time => {
                    if (!this.form.delegateStartTime) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
                    } else {
                        return (
                            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
                            || time.getTime() <= new Date(this.form.delegateStartTime).getTime()
                            || time.getTime() >=
                                new Date(new Date().toLocaleDateString()).getTime() + 365 * 3600 * 24 * 1000
                        )
                    }
                },
            }
        },
        endChange() {
            this.pickerOptionsStart = {
                disabledDate: time => {
                    if (!this.form.delegateEndTime) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
                    } else {
                        return (
                            time.getTime() < new Date(new Date().toLocaleDateString()).getTime() ||
                            time.getTime() >= new Date(this.form.delegateEndTime).getTime()
                        )
                    }
                },
            }
        },
        showpopover(example) {
            getExample(example).then(res => {
                const blob = new Blob([res], { type: 'text/plain' })
                this.$set(this.imgSrcPathObj, example, URL.createObjectURL(blob))
            })
        },
        /** 附件预览 **/
        view(data) {
            if (this.form[data.fileTemUrl] || this.form[data.fileUrl]) {
                this.rowData = {
                    downUrl: this.form[data.fileTemUrl] || this.form[data.fileUrl],
                    fileName: this.form[data.fileName],
                    fileId: this.form[data.fileId],
                }
                this.attachmentList = this.allAttachmentList
                this.attachmentShow = true
            } else {
                uploadList.forEach(e => {
                    if (e.fileUrl === data.fileUrl) {
                        this.$message.warning(e.errMsg)
                    }
                })
            }
        },
        /** 身份证同步到从业资格证 **/
        handleSync() {
            this.form.empCertificate = this.form.idCard
            this.form.empCertificateFileId = this.form.idCardFileId
            this.form.empCertificateFileName = this.form.idCardFileName
            this.form.empCertificateFileUrl = this.form.idCardFileUrl
        },
        /** 附件下载 **/
        handleDownloadTemplate(fileName, localFileName, type) {
            downloadAttachment(JSON.stringify({ fileName: fileName })).then(res => {
                let fileType = ''
                if (type === 'docx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                }
                if (type === 'xlsx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
                if (type === 'pptx') {
                    fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                }
                const blob = new Blob([res], {
                    type: fileType,
                })
                const objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = objectUrl
                a.download = localFileName
                a.click()
            })
        },
        /** 提交完毕后，把父组件的标志位都复原 **/
        handleRecover() {
            this.loading = false
            this.firstFlag = 0
            this.$message.success('保存成功！')
            this.allow = false
            this.$emit('update:addOrEdit', false)
            this.$emit('confirmDialog', false)
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.dealWithNewUploadVersionPageLogic()
        },
        handleRevoke() {
            this.$confirm('是否确定撤回？', '撤回确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                revokeApprove(this.id).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('撤回成功！')
                        this.closeDialog()
                    }
                })
            })
        },
        // 关闭对话框之前回调
        closeDialog() {
            this.firstFlag = 0
            this.$emit('closeDialog', false)
            this.form = JSON.parse(JSON.stringify(driverPublicForm))
            this.delegateOnline = ''
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.rules.delegateFileName[0].required = false
            this.rules.delegateStartTime[0].required = false
            this.rules.delegateEndTime[0].required = false
        },
        dialogClosed() {
            this.dealWithNewUploadVersionPageLogic()
        },
        handleSetLoading() {
            this.loading = true
            setTimeout(() => {
                this.loading = false
            }, 3000)
        },
        // 旧版提交
        confirmDialog() {
            Promise.resolve(this.$refs.form.validate()).then(async res => {
                const form = JSON.parse(JSON.stringify(this.form))
                form.idCard = form.idCard.toUpperCase()
                form.drivingLicence = form.drivingLicence.toUpperCase()
                form.countryName = this.handleGetCountryName()
                form.provinceName = this.handleGetProvinceName()
                form.cityName = this.handleGetCityName()
                // 供应商编码在平台端和供应端的取值
                const isSupplier = this.$store.state.supplier
                form.supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode
                let reqParams
                if (this.isLegalPersonSupplier) {
                    reqParams = this.dealWithReqParams(form)
                } else {
                    reqParams = form
                    reqParams.delegateOnline = '0'
                }
                // 委派函是否正确标识
                let flag = false
                // 选择了线下，就要校验上传的委派函是否正确
                if (reqParams.delegateOnline === DELEGATE_TYPE.OFFLINE && this.isLegalPersonSupplier) {
                    if (form.delegateFileUrl) {
                        await checkWPH(form.delegateFileUrl).then(res => {
                            if (res && +res.code === 0) {
                                flag = true
                            }
                        })
                    } else {
                        flag = false
                    }
                } else {
                    flag = true
                }
                if (flag) {
                    const reqMethod = this.id ? editDriver : addDriver
                    this.handleSetLoading()
                    reqMethod(reqParams).then(res => {
                        if (res && +res.code === 0) {
                            this.handleRecover()
                        }
                    })
                }
            })
            bigDataLog.sendDetailMessageByKey('bigData-btn-d-submitOld')
        },
        handleCheckSuccess() {
            this.allow = false
            this.$emit('update:addOrEdit', false)
        },
        handleInitArea() {
            this.provinceOptions = []
            this.cityOptions = []
        },
        uploadSuccess(data) {
            const info = data.data.ocrResult
            const name = data.flag.split('#')[0] // 文件名
            const url = data.flag.split('#')[1] // 文件url
            const id = data.flag.split('#')[2] // 文件id
            const temUrl = url.replace('Url', 'TemUrl')
            if (name === 'delegateFileName' || name === 'empCertificateFileName') {
                // 委派函和从业资格证上传不使用orc
                this.$set(this.form, name, data.data.data.localFileName)
                this.$set(this.form, url, data.data.data.downUrl)
                this.$set(this.form, temUrl, data.data.data.downUrl)
                this.$set(this.form, id, data.data.data.id)
            } else {
                // 使用orc
                this.$set(this.form, name, data.data.ossResult.localFileName)
                this.$set(this.form, url, data.data.ossResult.downUrl)
                this.$set(this.form, temUrl, data.data.ossResult.downUrl)
                this.$set(this.form, id, data.data.ossResult.id)
            }
            if (name === 'delegateFileName') {
                this.delegateDisabled = false
                this.rules.delegateStartTime[0].required = true
                this.rules.delegateEndTime[0].required = true
                this.form.delegateStartTime = ''
                this.form.delegateEndTime = ''
                this.showDelegateUpload = false
            }
            this.handleGetAllAttachmentList()
            if (name === 'idCardFileName') this.handleBringOutIdCard(info) // 身份证正面
            if (name === 'idCardBottomSideFileName') this.handleBringOutIdCardBottom(info) // 身份证反面
            if (name === 'drivingLicenceFileName') this.handleBringOutDrivingLicence(info) // 驾驶证
        },
        // 设置上传身份证正面后带出来的数据
        handleBringOutIdCard(info) {
            if (!info) {
                this.$message.warning('相片真实性或清晰度欠佳，若条件允许，建议重新上传')
                return
            } // 防止相片不清晰后台传回null
            if (!this.id) {
                // 新增才能修改<姓名>、<身份证号>
                this.form[idCardBringOutFieldsConfig[0].field] = info.name // 姓名
                this.form[idCardBringOutFieldsConfig[1].field] = info.idNumber // 身份证号
                this.$refs['refidCardNo'].resetField() // 新增时覆盖掉之前上传带出的信息
                this.$refs['refidCardCont'].resetField()
                this.$refs['refidCardTel'].resetField()
            }
            this.form[idCardBringOutFieldsConfig[2].field] = info.address // 地址
            idCardBringOutFieldsConfig.forEach((e, i) => {
                if (i > 2) {
                    switch (e.type) {
                        case 'text':
                            this.form[e.field] = info[e.field] || ''
                            break
                        case 'date':
                            this.form[e.field] = verifyDate(info[e.field])
                            break
                    }
                }
            })
            if (!info.name || !info.idNumber || !info.address) {
                this.$message.warning('身份证相片真实性或清晰度欠佳，若条件允许，建议重新上传')
            }
            this.handleGetAllAttachmentList()
        },
        // 设置上传身份证反面后带出来的数据
        handleBringOutIdCardBottom(info) {
            if (!info) {
                this.$message.warning('相片真实性或清晰度欠佳，若条件允许，建议重新上传')
                return
            }
            this.form.idCardStartDate = verifyDate(info.idCardStartTime)
            this.form.authorityIssue = info.issueAuthority
            this.form.idCardEndDate = info.idCardEndTime === '长期' ? '2099-12-31' : verifyDate(info.idCardEndTime)
            if (!info.idCardStartTime || !info.idCardEndTime) {
                this.$message.warning('身份证相片真实性或清晰度欠佳，若条件允许，建议重新上传')
            }
        },
        // 设置上传驾驶证后带出来的数据
        handleBringOutDrivingLicence(info) {
            if (!info) {
                this.$message.warning('相片真实性或清晰度欠佳，若条件允许，建议重新上传')
                return
            }
            this.form.sex = info.sex === '男' ? '1' : info.sex === '女' ? '2' : '' // ocr返回男女字符串，前端转为数字字典1，2
            this.form.drivingLicence = info.mainNumber
            this.form.driveType = info.drivetype
            this.form.mainNationality = info.mainNationality
            this.form.dateIssue = verifyDate(info.issueDate)
            this.form.driveStartDate = verifyDate(info.validFrom)
            this.form.driveEndDate = info.validTo === '长期' ? DATE_FOREVER : verifyDate(info.validTo)
            if ([!info.mainNumber, !info.drivetype, !info.sex, !info.validFrom, !info.validTo].includes(true)) {
                this.$message.warning('驾驶证相片真实性或清晰度欠佳，若条件允许，建议重新上传')
            }
        },
        handleGetAllAttachmentList() {
            const list = []
            const urlList = [
                'idCardFileTemUrl',
                'idCardBottomSideFileTemUrl',
                'drivingLicenceFileTemUrl',
                'empCertificateFileTemUrl',
                'delegateFileTemUrl',
            ]
            urlList.forEach(e => {
                list.push(this.form[e])
            })
            this.allAttachmentList = list.filter(item => {
                if (item) return item
            })
        },
        handleRequired(propertyNature) {
            // let boole = false
            // // 从业资格证, 从业资格证号
            // const fields = ['empCertificateFileName', 'empCertificate']
            // if (propertyNature === PERSON) {
            //     boole = true
            // }
            // fields.forEach(e => {
            //     this.rules[e][0].required = boole
            // })
        },
        handleGetCountryName() {
            let result = ''
            this.countryOptions.forEach(e => {
                if (this.form.countryCode === e.value) {
                    result = e.label
                }
            })
            return result
        },
        handleGetProvinceName() {
            let result = ''
            this.provinceOptions.forEach(e => {
                if (this.form.provinceCode === e.value) {
                    result = e.label
                }
            })
            return result
        },
        handleGetCityName() {
            let result = ''
            this.cityOptions.forEach(e => {
                if (this.form.cityCode === e.value) {
                    this.form.cityCode = e.value
                    result = e.label
                }
            })
            return result
        },
        viewDelegateFileFn() {
            this.showDelegateFlag = true
        },
    },
    computed: {
        country() {
            return this.form.countryCode
        },
        province() {
            return this.form.provinceCode
        },
        city() {
            return this.form.cityCode
        },
    },
    watch: {
        'openAddOrEditDialog'(nVal) {
            if (nVal) {
                this.dealWithOpenLogic()
                getCountrys().then(res => {
                    this.firstFlag += 1
                    this.countryOptions = [].concat(res)
                })
            }
        },
        'manage': {
            handler(nVal) {
                // 工作台新增司机，manage为false，需要调接口拿到当前供应商编码
                if (!nVal) {
                    getLoginUser().then(res => {
                        if (res && +res.code === 0) {
                            this.supplierCode_ = res.data.supplierCode
                            this.corporateIdCard_ = res.data.idCard
                            this.handleRequired(res.data.propertyNature)
                        }
                    })
                }
            },
            immediate: true,
        },
        'supplierCode': {
            handler(nVal) {
                if (nVal) this.supplierCode_ = nVal
            },
            immediate: true,
        },
        'corporateIdCard': {
            handler(nVal) {
                if (nVal) this.corporateIdCard_ = nVal
            },
            immediate: true,
        },
        'propertyNature': {
            handler(nVal) {
                this.handleRequired(nVal)
            },
            immediate: true,
        },
        'country'(nVal) {
            if (nVal) {
                getProvinces(nVal).then(res => {
                    this.firstFlag += 1
                    this.provinceOptions = [].concat(res)
                    if (this.firstFlag > THREE) {
                        this.$set(this.form, 'provinceCode', '')
                        this.$set(this.form, 'cityCode', '')
                    }
                })
            }
        },
        'province'(nVal) {
            if (nVal) {
                if (!this.form.countryCode) {
                    this.$message.warning('请选择国家')
                    this.$set(this.form, 'provinceCode', '')
                } else {
                    getCitys(nVal).then(res => {
                        this.firstFlag += 1
                        this.cityOptions = [].concat(res)
                        if (this.firstFlag > THREE) {
                            this.$set(this.form, 'cityCode', '')
                        }
                    })
                }
            } else {
                this.$set(this.form, 'cityCode', '')
            }
        },
        'city'(nVal) {
            if (nVal) {
                if (!this.form.provinceCode || !this.form.countryCode) {
                    this.$message.warning('请选择国家和省份')
                    this.$set(this.form, 'cityCode', '')
                }
            }
        },
        'form.idCard': {
            handler() {
                if (this.$refs['form']) {
                    if (this.form.idCard) {
                        this.form.idCard = this.form.idCard.toUpperCase()
                    }
                    this.$refs['form'].validateField('drivingLicence')
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        const haspermission = this.$store.getters.btnPermissions.find(el => {
            return el === '04000095'
        })
        this.btnpermission = haspermission !== undefined
        dictWithUrl(
            'SRM_AUDIT_STATUS,SRM_DRIVER_AUDIT_TYPE,SRM_REGISTER_SOURCE,SRM_DRIVER_CAR_APPROVAL_MODE,SRM_BUSYNESS_TYPE_BACKGROUND',
        ).then(res => {
            this.dict = res.data
        })
    },
}
